<template>
  <font-awesome-icon
    icon="users"
    size="lg"
    class="icon"
    @click.stop="showEntry()"/>
</template>

<script>
export default {
  props: {
    event: {
      required: true,
      type: Object
    }
  },

  methods: {
    showEntry: function () {
      this.$router.push({
        name: 'event-entry',
        params: { id: this.event.id}
      })
    },
  }
}
</script>

